import { render, staticRenderFns } from "./BasicThank.vue?vue&type=template&id=c7f1b826&scoped=true&"
import script from "./BasicThank.vue?vue&type=script&lang=js&"
export * from "./BasicThank.vue?vue&type=script&lang=js&"
import style0 from "./BasicThank.vue?vue&type=style&index=0&id=c7f1b826&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7f1b826",
  null
  
)

export default component.exports